export default __webpack_public_path__ + "static/6828-3659db1e752b83511b5a4c009f3ac000.jpg";